import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./libre-baskerville-latin.woff2%22,%22weight%22:%22400%22,%22display%22:%22swap%22}],%22variableName%22:%22libreBaskervilleRegular%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'libreBaskervilleRegular', 'libreBaskervilleRegular Fallback'",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
